import { memo } from "react";

import { hyphenate } from "neetocist";
import useHotkeys from "neetohotkeys";
import { Check, Close } from "neetoicons";
import { Button, Input } from "neetoui";
import { useTranslation } from "react-i18next";

import { PhoneNumberInput } from "components/PhoneNumber";

import { ENTER, ESCAPE, PHONE_NUMBER } from "./constants";
import { getInputType, mergeRefs } from "./utils";

const EditField = ({
  name,
  error,
  label,
  kind,
  value,
  handleChange,
  handleMetadataCancel,
  handleMetadataSubmit,
}) => {
  const { t } = useTranslation();

  const enterRef = useHotkeys(ENTER, handleMetadataSubmit, {
    mode: "scoped",
  });

  const cancelRef = useHotkeys(ESCAPE, handleMetadataCancel, {
    mode: "scoped",
  });

  const InputComponent = name === PHONE_NUMBER ? PhoneNumberInput : Input;

  return (
    <div className="neeto-molecules-session-environment-editable-field relative flex min-w-0 flex-grow items-center">
      <InputComponent
        {...{ error }}
        autoFocus
        data-testid={`metadata-input-${hyphenate(name)}`}
        placeholder={t("neetoMolecules.common.enter", { what: label })}
        ref={mergeRefs(enterRef, cancelRef)}
        type={getInputType({ name, kind })}
        value={value || ""}
        onChange={handleChange}
      />
      <div className="neeto-molecules-session-environment-editable-field__actions absolute end-0 top-0 flex h-8 items-center pe-1">
        <Button
          data-testid={`metadata-cancel-${hyphenate(name)}`}
          icon={Close}
          size="small"
          style="text"
          tooltipProps={{
            content: t("neetoMolecules.common.actions.cancel"),
            position: "top",
          }}
          onClick={handleMetadataCancel}
        />
        <Button
          data-testid={`metadata-submit-${hyphenate(name)}`}
          icon={Check}
          size="small"
          style="text"
          tooltipProps={{
            content: t("neetoMolecules.common.actions.save"),
            position: "top",
          }}
          onClick={handleMetadataSubmit}
        />
      </div>
    </div>
  );
};

export default memo(EditField);
